import dynamic from 'next/dynamic';
import { PlannerHeaderProps } from './PlannerHeader.types';

export const PlannerHeader = dynamic<{ model: PlannerHeaderProps }>(() =>
  import('./PlannerHeader').then(mod => mod.PlannerHeader)
);
